// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Um5P","content":"styles_content__3wDpu"};